<div class="d-flex justify-content-between align-items-center pt-4 pb-3">
  <div class="d-flex flex-row align-items-center gap-3">
    <base-avatar
      [image]="provider?.logo?.data"
      [size]="avatarSize.large"
      [isCompany]="true"
    ></base-avatar>
    <div class="d-flex flex-column">
      <h2 class="mb-0 headline-32">{{ provider?.pspLegalName }}</h2>
      <h3 class="mb-0 headline-20 text-dark-gray">{{ provider?.pspBranchName }}</h3>
    </div>
  </div>
  <div>
    <i
      class="fa-solid fa-circle-xmark pointer fa-2x"
      (click)="closeDetailsModal()"
    ></i>
  </div>
</div>

<base-horizontal-nav
  class="m-3"
  [tabs]="tabs"
  [current]="currentTab"
  (tabChange)="onTabChange($event)"
></base-horizontal-nav>

<div class="overflow-modal-content">
  <div class="modal-tab-content">
    <ng-container *ngIf="currentTab?.id === providerTabsEnum.MaterData">
      <base-customer-provider-details-master-data [pspId]="provider.pspId"></base-customer-provider-details-master-data>
    </ng-container>
    <ng-container *ngIf="currentTab?.id === providerTabsEnum.EmployeeLease">
      <base-customer-provider-details-employee-lease></base-customer-provider-details-employee-lease>
    </ng-container>
    <ng-container *ngIf="currentTab?.id === providerTabsEnum.IZS">
      <base-customer-provider-izs-info [pdlId]="provider.izsAccountId"></base-customer-provider-izs-info>
    </ng-container>
  </div>
</div>
